import { render } from "./HomeLatestPopularCourseList.vue?vue&type=template&id=4fb71667&scoped=true&ts=true"
import script from "./HomeLatestPopularCourseList.vue?vue&type=script&lang=ts"
export * from "./HomeLatestPopularCourseList.vue?vue&type=script&lang=ts"

import "./HomeLatestPopularCourseList.vue?vue&type=style&index=0&id=4fb71667&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb71667"]])

export default __exports__